import axios from 'axios'

const state = {
    msgThread: null,
    itemBuyers: null,
    itemsSeller: null,
    masItemBuyers: null,
    masItemsSeller: null,
    // Remeber that -> MAS == mas == Mark As Sold 
}

const getters = {
    itemBuyers (state) {
        return state.itemBuyers
    },
    itemsSeller (state) {
        return state.itemsSeller
    },
    masItemBuyers (state) {
        return state.masItemBuyers
    },
    masItemsSeller (state) {
        return state.masItemsSeller
    },
    msgThread (state) {
        return state.msgThread
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {
    async fetchItemBuyers({ commit, getters }, itemObj) {
        let sellerObj = { sellerId: getters.user._id }
        // used to fetch buyers related to a specific item - for MarkAsSold.vue page
        if(itemObj){ sellerObj = itemObj }
        let response = await axios.post('/messages/sellerItemBuyers', sellerObj)
        if(!response.data.error){
            if(itemObj){ return commit('MAS_ITEM_BUYERS', response.data.result) }
            return commit('ITEM_BUYERS', response.data.result) 
        }
    },
    
    async fetchItemsSeller({ commit, getters }, itemObj) {
        let buyerObj = { buyerId: getters.user._id }
        // used to fetch seller related to a specific item - for MarkAsSold.vue page
        if(itemObj){ buyerObj = itemObj }
        let response = await axios.post('/messages/buyerItemsSeller', buyerObj)
        if(!response.data.error){
            if(itemObj){ return commit('MAS_ITEMS_SELLER', response.data.result) }
            return commit('ITEMS_SELLER', response.data.result) 
        }
    },
    
    async fetchMsgThread({ commit }, threadObj) {
        let response = await axios.post('/messages/thread', threadObj)
        if(!response.data.error){
            return commit('MSG_THREAD', response.data.result) 
        }
    },
    
    async sendNewMessage({ dispatch, getters }, messageObj) {
        let response = await axios.post('/messages/newMessage', messageObj)
        /* modify the messageObj to change the receiverId from the initial 
        receiver (could be buyers or sellers) to now be the loggedIn user, 
        this allows it perform markRead check in /messages/thread API */
        messageObj.receiverId = getters.user._id
        dispatch('fetchMsgThread', messageObj) 
        return response.data.result
    },
    
    async approveRequest({ _ }, messageObj) {
        await axios.post('/messages/approveMsg', messageObj)
    },
    
    async declineRequest({ _ }, messageObj) {
        await axios.post('/messages/removeMsg', messageObj)
    },

}

const mutations = {
    MSG_THREAD: (state, msgThread) => (state.msgThread = msgThread),
    ITEM_BUYERS: (state, itemBuyers) => (state.itemBuyers = itemBuyers),
    ITEMS_SELLER: (state, itemsSeller) => (state.itemsSeller = itemsSeller),
    MAS_ITEM_BUYERS: (state, masItemBuyers) => (state.masItemBuyers = masItemBuyers),
    MAS_ITEMS_SELLER: (state, masItemsSeller) => (state.masItemsSeller = masItemsSeller),
}

export default {
    state,
    getters,
    actions,
    mutations
}